"use client";

import { Loader } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { Suspense } from "react";
import { UI } from "./UI";
import { Experience } from "./Exprience";

function BookSection() {
  // const [showTooltip, setShowTooltip] = useState(false);
  // const [pos, setPos] = useState({ x: 0, y: 0 });

  // useEffect(() => {
  //   const moveTooltip = (e: MouseEvent) => {
  //     setPos({ x: e.clientX, y: e.clientY });
  //   };

  //   if (showTooltip) {
  //     window.addEventListener("mousemove", moveTooltip);
  //   } else {
  //     window.removeEventListener("mousemove", moveTooltip);
  //   }

  //   return () => window.removeEventListener("mousemove", moveTooltip);
  // }, [showTooltip]);

  return (
    <div className="wrapper bookBackground">
      <div className="grid lg:grid-cols-4">
        {/* Left content */}
        <div className="col-span-1 flex items-center">
          <div className="w-full">
            <h2 className="text-3xl md:text-4xl text-yellow-500 font-bold mb-8 md:mb-12 text-nowrap">
              Behind the Magic —
            </h2>
            <p className="heading2 text-white mb-6 text-justify">
              How our team of game devs works to create the magic. <br />
            </p>
            
          </div>
        </div>

        {/* Right - 3D book section */}
        <div
          className="
            w-full 
            min-w-[300px]
            min-h-[300px]
            sm:min-h-[650px]
            aspect-[16/9]  
            lg:aspect-[21/9] 
            col-span-3 
            relative
          "
        /*onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)} */
        >
          <UI />
          <Loader
            containerStyles={{
              backgroundColor: "transparent",
            }}
          />
          <Canvas
            shadows
            camera={{
              position: [-0.05, -1, 4],
              fov: 30,
            }}
            style={{ width: "100%", height: "100%", cursor: "pointer" }}
          >
            <group position-y={0}>
              <Suspense fallback={null}>
                <Experience />
              </Suspense>
            </group>
          </Canvas>

          {/* Tooltip */}
          {/* {showTooltip && (
            <div
              className="pointer-events-none fixed z-50 px-3 py-1 bg-yellow-400 text-black text-sm font-bold rounded-lg shadow-lg animate-pulse"
              style={{
                left: pos.x + 15,
                top: pos.y + 15,
              }}
            >
              Click here
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}

export default BookSection;
